import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { BffAgcoUserDetailsResponse } from '@lucky7ventures/bff-types';

import { ModalLayout } from '@/features/modal/modals/ModalLayout';
import Spinner from '@/components/UI/Spinner';
import DetailsReverificationForm from '@/components/DetailsReverificationForm';
import { selectUser } from '@/store/selectors/userSelectors';
import { GTagEvents, triggerGTag } from '@/lib/gTagManager';
import { useBffApiRequest } from '@/hooks/useBffApiRequest';
import BffApiService from '@/shared/bffApiService';
import { BaseModalProps } from '@/features/modal/types';

export const DetailsReverificationModal = ({ closeModal }: BaseModalProps) => {
  const intl = useIntl();
  const user = useSelector(selectUser);
  const {
    request: additionalUserDataRequest,
    data: additionalUserDetails,
    loading: additionalUserDetailsLoading,
    success: additionalUserDetailsSuccess,
    error: additionalUserDetailsError,
  } = useBffApiRequest<BffAgcoUserDetailsResponse>();

  const shouldShowCloseButton =
    !additionalUserDetailsLoading &&
    !additionalUserDetails &&
    (additionalUserDetailsSuccess || additionalUserDetailsError);

  useEffect(() => {
    additionalUserDataRequest({ apiMethod: BffApiService.getAgcoUserDetails });
    triggerGTag(GTagEvents.reverification_triggered);
  }, []);

  return (
    <ModalLayout
      close={shouldShowCloseButton ? closeModal : undefined}
      data-cy="e2e_detailsReverificationModal"
      className="!max-w-md"
    >
      <div className="w-full">
        <h1 className="mb-4 text-center text-lg font-bold">
          {intl.formatMessage({ id: 'detailsReverification.title' })}
        </h1>
        <p className="text-center">{intl.formatMessage({ id: 'detailsReverification.text' })}</p>
        {additionalUserDetails && user ? (
          <DetailsReverificationForm
            user={user}
            additionalUserDetails={additionalUserDetails}
            closeModal={closeModal}
          />
        ) : (
          <div className="flex justify-center w-full">
            <Spinner />
          </div>
        )}
      </div>
    </ModalLayout>
  );
};
